import React, { useRef, useEffect, useState } from 'react';

const SvgHist = () => {
  const svgRef = useRef();
  const [rects, setRects] = useState([]);
  const [widthStep, setWidthStep] = useState(10);

  useEffect(() => {
    const recs = [];
    for(let i = 0; i < 10; i++) {
      recs.push(i);
    }
    setRects(recs);
    setWidthStep(svgRef.current.clientWidth / recs.length);
    window.onload = () => {
      setRects(recs);
      setWidthStep(svgRef.current.clientWidth / recs.length);
    }
  }, []);

  return (
    <>
      <h1 className="text-center">svg 绘制直方图</h1>
      <div ref={svgRef}>
        <svg width="100%" height="300">
          {rects.map(rect => {
            const height = Math.random() * 255;
            return (
              <React.Fragment key={rect}>
                <rect
                  x={widthStep * rect}
                  y={300 - height}
                  width={widthStep - 10}
                  height={height}
                  onClick={() => setRects(recs => [...recs])}
                  fill={`rgb(${height}, ${Math.random() * 255}, ${Math.random() * 255})`}
                  style={{cursor: 'pointer'}}
                />
                <text 
                  x={widthStep * rect + (widthStep - 10) / 2 - `${Math.floor(height)}`.length * 9.5 / 2}
                  y={300 - height - 3}
                  fill="#000"
                >
                  {Math.floor(height)}
                </text>
              </React.Fragment>
            )
          })}
        </svg>
      </div>
    </>
  )
}

export default SvgHist;
